<template>
    <nav class="navbar header-navbar pcoded-header">
        <div class="navbar-wrapper d-flex">

            <div class="navbar-logo">
                <a class="mobile-menu" id="mobile-collapse" href="javascript:void(0)">
                    <i class="ti-menu"></i>
                </a>
                <a href="/dashboard" style="height: 50px; width: 100px; margin-top: 0px;">
                    <img class="img-fluid" src="../assets/img/sundry_food_logo.png" alt="Sundry Foods Recruitment Portal" />
                </a>
                <a class="mobile-options">
                    <i class="ti-more"></i>
                </a>
            </div>

            <div class="navbar-container container-fluid">
                <ul class="nav-left">
                    <li>
                        <div class="sidebar_toggle"><a href="javascript:void(0)"><i class="ti-menu"></i></a></div>
                    </li>
                    <li v-on:click="goBack" v-if="can_go_back">
                        <a href="javascript:void(0)">
                            <i class="ti-arrow-left"></i>
                        </a>
                    </li>
                    <li v-else>
                        <a href="javascript:void(0)" class="disabled">
                            <i class="ti-arrow-left"></i>
                        </a>
                    </li>
                    <li class="hidden-md">
                        <i class="ti-search"></i>
                        <input type="text" name="search" class="global-search" placeholder="Search Candidates by Name, Phone, Email, Referer, etc..."
                            v-model="search_query" v-on:keyup="search" />
                    </li>
                </ul>
                <ul class="nav-right">
                    <li class="user-profile header-notification">
                        <a href="javascript:void(0)">
                            <img src="../assets/img/avatar-4.jpg" class="img-radius" alt="User-Profile-Image">
                            <span>{{user_name}}</span>
                            <i class="ti-angle-down"></i>
                        </a>
                        <ul class="show-notification profile-notification">
                            <li>
                                <a href="/settings">
                                    <i class="ti-settings"></i> Settings
                                </a>
                            </li>
                            <li>
                                <a href="" v-on:click.prevent="logout">
                                    <i class="ti-layout-sidebar-left"></i> Logout
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<style scoped>
    ul {
        padding-left: 0 !important;
        list-style-type: none !important;
        margin-bottom: 0 !important;
    }

    .global-search {
        width: 480px;
        height: 45px;
        margin-top: 15px;
        padding: 7px;
        border: none;
        border-bottom: 1px solid #ccc;
        font-size: 16px;
    }

    .global-search-results {
        position: absolute;
        width: 100%;
        background: #fff;
        padding-left: 50px;
        padding-right: 50px;
        margin-top: 80px;
        min-height: 500px;
    }

    .disabled {
        color: #ccc !important;
        pointer-events: none;
    }
</style>
<script>
    export default {
        name: 'navbar1',
        data() {
            return {
                user_name: '',
                search_query: '',
                can_go_back: false
            }
        },
        methods: {
            logout() {

                var r = window.confirm('Are you sure you want to logout?')

                if (r == true) {
                    this.$store.dispatch('logout')
                    window.location.reload()
                    //console.log(this.$store.getters)
                } else {
                    //
                }
            },

            goBack() {
                window.history.go(-1)
            },

            search: function (event) {

                if (event.which == 13 || event.keyCode == 13) {

                    let q = '/searchresults/?q=' + this.search_query

                    window.location.href = q
                }
            }
        },
        mounted() {
            var user = this.$store.getters.user_data

            this.user_name = user.data.first_name + " " + user.data.last_name

            this.can_go_back = window.history.length > 1
        }
    }
</script>